import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
  selector: '[artHasFormControl]',
})
export class HasFormControlDirective {
  private templateRef = inject(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);

  @Input('artHasFormControl')
  set hasFormControlInput(value: [FormGroup, string]) {
    const [form, controlName] = value;

    if (form && form.contains(controlName)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
